import { ProfileShowView } from '@/views/authenticated/profile';

export default [
  {
    path: '/profile',
    name: 'app_profile',
    meta: { title: 'My Profile' },
    component: ProfileShowView,
  },
];
